import { environment, inAppProducts } from '../../../environments/environment';
import { BasePage } from '../base.page';
import { finalize, switchMap, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { OfferService } from '../../services/offer.service';
import {
  InAppService,
  Product,
  PurchaseEventType,
} from 'src/app/services/in-app.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  NgZone,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import {
  LoadingController,
  ModalController,
  Platform,
  ToastController,
} from '@ionic/angular';
import { CancelSubscriptionComponent } from 'src/app/components/cancel-subscription/cancel-subscription.component';
import { EMPTY, from, Subscription } from 'rxjs';

@Component({
  selector: 'shc-subscriptions',
  templateUrl: './subscriptions.page.html',
  styleUrls: ['./subscriptions.page.scss'],
})
export class SubscriptionsPage extends BasePage implements OnInit {
  device: string;
  loading: boolean;
  selectedProduct: Product;
  hideProducts: boolean;
  products: Array<Product>;
  productId: string;
  subscription: Subscription;

  constructor(
    protected platform: Platform,
    protected userService: UserService,
    protected authService: AuthService,
    protected translate: TranslateService,
    private errorService: ErrorHandlerService,
    protected loadingCtrl: LoadingController,
    toastController: ToastController,
    private router: Router,
    private route: ActivatedRoute,
    private modalCtrl: ModalController,
    public inAppService: InAppService,
    private offerService: OfferService,
    private ref: ChangeDetectorRef,
    private readonly ngZone: NgZone,
  ) {
    super(
      platform,
      userService,
      authService,
      translate,
      loadingCtrl,
      toastController,
    );
    this.products = [];
    userService.updatedUser.subscribe((resp) => {
      this.selectedProduct = resp?.productId;
      this.user$.next(resp);
      this.ref.detectChanges();
    });
  }

  ngOnInit() {
    this.ngZone.run(() => {
      this.products = this.inAppService.products;

      console.log('PRODUCTS:', this.products);

      this.subscription = this.inAppService.isSubscribed
        .pipe(takeUntil(this.destroy))
        .subscribe((subscribed) => {
          if (subscribed?.has_subscription) {
            this.productId = subscribed.product_id;
          } else {
            this.productId = undefined;
          }
        });

      this.selectedProduct =
        this.products.find((item) => item.id === this.productId) ?? null;
    });
  }

  ionViewWillEnter() {
    this.loading = true;
    this.user$.subscribe((res) => {
      if (
        this.platform.is('android') &&
        res?.is_premium === 1 &&
        res?.subscriptionType === 'ios-appstore'
      ) {
        this.device = 'IOS';
        this.loading = false;
        this.hideProducts = true;
      } else if (
        this.platform.is('ios') &&
        res?.is_premium === 1 &&
        res?.subscriptionType === 'android-playstore'
      ) {
        this.loading = false;
        this.device = 'Android';
        this.hideProducts = true;
      } else {
        this.loading = false;
        this.hideProducts = false;
      }
    });
  }

  handleSubscription(product: Product) {
    if (!product || !product.canPurchase) {
      return;
    }

    if (this.inAppService.isPurchasing) {
      this.errorService.showToast(
        this.translate.instant('IAP.PurchaseInProgress'),
      );

      return;
    }

    return from(this.showLoader())
      .pipe(
        switchMap(() => {
          if (product.owned) {
            this.errorService.showToast(
              this.translate.instant('Subscription.AlreadySubscribed'),
            );
            return EMPTY;
          }

          return this.inAppService.handleSubscription(product.id);
        }),
        finalize(() => this.hideLoader()),
      )
      .subscribe({
        next: (event) => {
          switch (event.event) {
            case PurchaseEventType.ERROR: {
              this.errorService.handleIapError(event.error);

              break;
            }
            case PurchaseEventType.FINISHED: {
              if (event.product.owned) {
                this.errorService.showToast(
                  this.translate.instant('Subscription.Purchase.Subscribed'),
                );
              } else {
                this.errorService.showToast(
                  this.translate.instant('Subscription.Purchase.Unowned'),
                );
              }

              this.selectedProduct = this.products.find(
                (item) => item?.id === product?.id,
              );
              this.productId = product?.id;
              this.errorService.showToast(
                this.translate.instant('Subscription.Purchase.Subscribed'),
              );

              break;
            }
            case PurchaseEventType.UNVERIFIED: {
              if (this.platform.is('ios')) {
                this.errorService.showToast(
                  this.translate.instant(
                    'Subscription.Purchase.ValidationFailed.Apple',
                  ),
                );
              } else {
                this.errorService.showToast(
                  this.translate.instant(
                    'Subscription.Purchase.ValidationFailed.Google',
                  ),
                );
              }

              break;
            }
          }
        },
        error: (error: unknown) => {
          console.warn('purchase error', error);

          this.errorService.handle(error);
        },
      });
  }

  protected readonly inAppProducts = inAppProducts;
}
